import { BillingPlanFlowProps, FormTier, PlatformFeePaidBy } from './data';

import { UpsertBillingPlanInput, PlatformFeePaidBy as platformFeePaidByFromSchema } from '../../../graphql/schema';
import { parseFloatFromNumberInputMask, parseMoneyFromNumberInputMask } from '../../../utils/input-helpers';

const buildPlatformFeeAllocation = (values: BillingPlanFlowProps) => {
  if (values.platformFeePaidBy === PlatformFeePaidBy.Shared && values.sharedPlatformFeeClientPortionBps !== undefined) {
    const clientPortion = parseFloatFromNumberInputMask(values.sharedPlatformFeeClientPortionBps);
    return {
      shared: {
        clientPortion,
      },
    };
  }
  if (values.platformFeePaidBy === PlatformFeePaidBy.AdvisorOnly) {
    return {
      notShared: {
        paidBy: platformFeePaidByFromSchema.AdvisorOnly,
      },
    };
  }
  return {
    notShared: {
      paidBy: platformFeePaidByFromSchema.ClientOnly,
    },
  };
};

export const makeUpsertBillingPlanInput = (values: BillingPlanFlowProps): UpsertBillingPlanInput => {
  if (values.configurationType === 'BillingRateAssetBased') {
    return {
      id: values.billingPlanId,
      // @ts-expect-error TS2322 violates strict null checks
      name: values.planName,
      // @ts-expect-error TS2322 violates strict null checks
      paymentType: values.paymentType,
      billingRate: {
        assetBasedConfiguration: {
          feeRate: parseFloatFromNumberInputMask(values.assetBasedFeeRate),
        },
      },
      platformFeeAllocation: buildPlatformFeeAllocation(values),
    };
  }
  if (values.configurationType === 'BillingRateFixed') {
    return {
      id: values.billingPlanId,
      // @ts-expect-error TS2322 violates strict null checks
      name: values.planName,
      // @ts-expect-error TS2322 violates strict null checks
      paymentType: values.paymentType,
      billingRate: {
        fixedConfiguration: {
          // @ts-expect-error TS2322 violates strict null checks
          feeAmount: parseMoneyFromNumberInputMask(values.fixedFeeAmount),
        },
      },
      platformFeeAllocation: buildPlatformFeeAllocation(values),
    };
  }
  if (values.configurationType === 'BillingRateTiered') {
    return {
      id: values.billingPlanId,
      // @ts-expect-error TS2322 violates strict null checks
      name: values.planName,
      // @ts-expect-error TS2322 violates strict null checks
      paymentType: values.paymentType,
      billingRate: {
        tieredConfiguration: {
          calculationMethod: values.tieredFeeCalculationMethod,
          // @ts-expect-error TS2322 violates strict null checks
          tiers: values.tiers?.map((tier: FormTier) => ({
            firmFee:
              tier.firmFee.feeConfigType === 'fixedConfiguration'
                ? {
                    fixedConfiguration: {
                      feeAmount: parseMoneyFromNumberInputMask(tier.firmFee.feeValue),
                    },
                    assetBasedConfiguration: undefined as never,
                  }
                : {
                    assetBasedConfiguration: {
                      feeRate: parseFloatFromNumberInputMask(tier.firmFee.feeValue),
                    },
                    fixedConfiguration: undefined as never,
                  },
            tierEnd: tier.tierEnd ? parseMoneyFromNumberInputMask(tier.tierEnd) : undefined,
          })),
        },
      },
      platformFeeAllocation: buildPlatformFeeAllocation(values),
    };
  }
  throw Error(`Unsupported billing plan form values to make upsert input: ${JSON.stringify(values)}`);
};
